// extracted by mini-css-extract-plugin
module.exports = {"page":"Agreement_page__2iYbs","title":"Agreement_title__OXNwd","info":"Agreement_info__3CqPy","tit":"Agreement_tit__3Tiya","fs":"Agreement_fs__14B1V","fw":"Agreement_fw__3GGM2"};